import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15e48560"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  height: "auto",
  class: "Section__Wrapper-sc-8gk3sk-0 jVCeUk Downloads__SectionWrap-snrphc-0 hFFJyh",
  width: "100vw",
  overflow: "hidden"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Downloads__HeroWrapper-snrphc-1 cSZTtk" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "styles__XLargeH-sc-1d0iomf-2 eheunP" }, "Certifications and partners"),
  /*#__PURE__*/_createElementVNode("h2", null, "Cosmo partners with selected organizations and companies to ensure that our mission to innovate and lead a sustainable transformation is on track.")
], -1))
const _hoisted_3 = { class: "Downloads__DownloadWrapper-snrphc-2 hcaMBp" }
const _hoisted_4 = { class: "img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://unglobalcompact.org/what-is-gc/participants/139321-Cosmo",
  target: "_blank"
}, "Read more...", -1))
const _hoisted_7 = { class: "img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/pdf/cosmo_sustanability_report_2020_final.pdf",
  target: "_blank"
}, "Cosmo 2019 Sustainability Report", -1))
const _hoisted_10 = { class: "img" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://greenbusinessca.org/",
  target: "_blank"
}, "Read more...", -1))

import { ref, reactive, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Certifications',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/images/cosmo_partner_goals.jpg?nf_resize=fit&w=250')
          }, null, 8, _hoisted_5)
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: require('@/assets/images/cosmo_partner_un-1.jpg?nf_resize=fit&w=250')
          }, null, 8, _hoisted_8)
        ]),
        _hoisted_9
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("img", {
            src: require('@/assets/images/cosmo_partner_green.jpg?nf_resize=fit&w=250')
          }, null, 8, _hoisted_11)
        ]),
        _hoisted_12
      ])
    ])
  ]))
}
}

})